import React, { Component } from 'react';
import { Container, Row, Col, Table, Button, Card } from 'react-bootstrap';
import { CartContext } from '../context/CartContext';
import CartItem from './CartItem'; 
import { FaArrowLeft } from 'react-icons/fa'; 
import { Link } from 'react-router-dom';
class CartComponent extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      isHovered: false,
    };
  }

  calculateTotal = () => {
    const { cartItems } = this.context;
    return cartItems.reduce((acc, item) => acc + item.price * item.quantity, 0).toFixed(2);
  };
  

 
  render() {
    const { cartItems, updateQuantity, removeItem } = this.context;
    const { isHovered } = this.state;

    const buttonStyle = {
      color: isHovered ? 'white' : '#9caf7d',
      borderColor: isHovered ? '#C62E2E' : '#9caf7d',
      backgroundColor: isHovered ? '#C62E2E' : 'transparent',
      marginLeft: '10px',
    };

    return (
      <Container>
        <Card style={{ marginTop: '100px', width: '100%', marginLeft: '-50px' }} className="shadow-lg rounded">
          <Card.Body>
            <center>
              <h1 className="my-4">Votre panier</h1>
            </center>
            <Row>
              <Col md={8}>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Produit</th>
                      <th>Prix</th>
                      <th>Quantité</th>
                      <th>Total</th>
                      <th>Supprimer</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cartItems.length > 0 ? (
                      cartItems.map(item => (
                        <CartItem
                          key={item.id}
                          item={item}
                          updateQuantity={updateQuantity}
                          removeItem={removeItem}
                        />
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" style={{ textAlign: 'center' }}>
                          Le panier est vide.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
                <h3>Total: {this.calculateTotal()} DT</h3>

                <Button
                  variant="outline-success"
                  style={buttonStyle} 
                  onMouseEnter={() => this.setState({ isHovered: true })}
                  onMouseLeave={() => this.setState({ isHovered: false })}
                >
                  <Link to="/accueil" className="nav-link"><FaArrowLeft /></Link>

                </Button>
              </Col>

              <Col md={4}>
                <div className="border p-3 rounded">
                  <h4>Résumé de la commande</h4>
                  <p>
                    <strong>Sous-total:</strong> {this.calculateTotal()} DT
                  </p>
                  <p>
                    <strong>Expédition:</strong>
                    <br /> Les options de livraison seront mises à jour lors de la commande.
                  </p>
                  <hr />
                  <h5>Total: {this.calculateTotal()} DT</h5>
                  <Button
                    variant="success"
                    className="mt-3"
                    style={{ width: '60%', backgroundColor: 'green', border: 'none' }}
                  >
                  <Link to="/facturation" className="nav-link">VALIDER LA COMMANDE</Link>
                                         
                  </Button>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    );
  }
}

export default CartComponent;
